'use client';

import { c as _c } from "react/compiler-runtime";
import IconTrustShield1 from '@/public/images/partner/icon_trust_shield_1.svg';
import IconTrustShield2 from '@/public/images/partner/icon_trust_shield_2.svg';
import IconTrustShield3 from '@/public/images/partner/icon_trust_shield_3.svg';
import TrustShieldBackground from '@/public/images/partner/trust-shield-background.png';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
export default function TrustShieldSection() {
  const $ = _c(46);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("partner.trust-shield.shield1.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("partner.trust-shield.shield1.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      icon: IconTrustShield1,
      title: t0,
      description: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("partner.trust-shield.shield2.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("partner.trust-shield.shield2.description");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      icon: IconTrustShield2,
      title: t3,
      description: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("partner.trust-shield.shield3.title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("partner.trust-shield.shield3.description");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      icon: IconTrustShield3,
      title: t6,
      description: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t5, t8];
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const trustItems = t9;
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image alt="BackgroundDecoration" className="pointer-events-none absolute top-[-200px] block min-h-[700px] min-w-[700px] md:top-[-150px] lg:top-[-200px] lg:h-[800px] lg:w-[800px]" src={TrustShieldBackground} />;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0,
      y: 20
    };
    t12 = {
      opacity: 1,
      y: 0
    };
    t13 = {
      once: true,
      amount: 0.2
    };
    t14 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t11 = $[26];
    t12 = $[27];
    t13 = $[28];
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("partner.trust-shield.title");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15) {
    t16 = <h2 className="text-center text-[28px] leading-[30px] font-extrabold tracking-[0.15px] text-white md:text-[38px] md:leading-10">{t15}</h2>;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("partner.trust-shield.subtitle");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17) {
    t18 = <p className="text-vive-primary-20 text-center text-base leading-[26px] tracking-[0.25px] md:max-w-[518px] md:text-lg md:leading-8">{t17}</p>;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t16 || $[39] !== t18) {
    t19 = <motion.div className="flex flex-col items-center gap-6" initial={t11} whileInView={t12} viewport={t13} transition={t14}><div className="relative flex flex-col items-center gap-4">{t16}{t18}</div></motion.div>;
    $[38] = t16;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== trustItems) {
    t20 = <div className="relative flex w-full flex-col gap-4 md:max-w-[340px] md:gap-6 lg:max-w-[636px]">{trustItems.map(_temp)}</div>;
    $[41] = trustItems;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19 || $[44] !== t20) {
    t21 = <section className="bg-background relative flex flex-col items-center py-12 md:px-8 md:py-20 lg:px-18 lg:py-16"><div className="relative flex w-full max-w-[1296px] flex-col items-center gap-6 px-4 py-16 md:gap-6 md:px-6 md:py-16">{t10}{t19}{t20}</div></section>;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  return t21;
}
function _temp(item, index) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.6,
    ease: "easeOut",
    delay: index * 0.12
  }} key={item.title} className="flex gap-2 md:gap-6"><div className="flex size-[72px] min-h-18 min-w-18 items-center justify-center rounded-2xl bg-linear-to-b from-[rgba(42,54,73,0.5)] to-[rgba(42,54,73,0.3)]"><item.icon /></div><div className="flex flex-col gap-1"><h3 className="text-base leading-6 font-medium tracking-[0.28px] text-white md:text-[18px] md:leading-6 md:font-medium md:tracking-[0.28px]">{item.title}</h3><p className="text-vive-primary-20 text-base leading-6 tracking-[0.25px] md:leading-6 md:tracking-[0.25px]">{item.description}</p></div></motion.div>;
}